/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type StatusWithDescription_programStatus = {
    readonly id: string;
    readonly createdAt: string | null;
    readonly createdBy: {
        readonly person: {
            readonly id: string;
            readonly fullName: string | null;
            readonly profilePictureId: string | null;
        } | null;
    } | null;
    readonly description: string | null;
    readonly ragStatus: string | null;
    readonly " $refType": "StatusWithDescription_programStatus";
};
export type StatusWithDescription_programStatus$data = StatusWithDescription_programStatus;
export type StatusWithDescription_programStatus$key = {
    readonly " $data"?: StatusWithDescription_programStatus$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"StatusWithDescription_programStatus">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StatusWithDescription_programStatus",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserType",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profilePictureId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ragStatus",
      "storageKey": null
    }
  ],
  "type": "ProjectServiceProgramStatusType"
};
})();
(node as any).hash = '7277cb7102b9bc53d7b749b554be0c2f';
export default node;
